<template>
  <div class="d-flex flex-column align-items-center justify-content-center">
    <h6 class="text-center mb-3">
      <i class="icon-exam"></i>
      Tentativa {{ score.number_of_attempts }} de
      {{ score.quiz.number_of_attempts }}
    </h6>
    <quiz-pie-chart
      :progress="score.score"
      :change-point="score.quiz.approval_average"
    />
    <h6 class="mt-3">{{ congrats }}</h6>
    <p class="mb-5">
      Você acertou {{ score.total_correct_answers }} de
      {{ score.quiz.questions.length }} perguntas
    </p>
    <div class="d-flex justify-content-center">
      <button
        v-if="isApproved && score.quiz.allow_reveal_answer_keys"
        class="btn px-4"
        :class="{
          'btn-light': $setup.theme == 'dark',
          'btn-primary': $setup.theme == 'light'
        }"
        @click="$emit('answer-keys')"
      >
        Gabarito
      </button>
      <button
        v-else-if="!isApproved && score.quiz.number_of_attempts > 1"
        class="btn px-4"
        :class="{
          'btn-light': $setup.theme == 'dark',
          'btn-primary': $setup.theme == 'light'
        }"
        @click="$emit('retry')"
      >
        <loading small :show="retryLoading">Tentar novamente</loading>
      </button>
      <button
        v-else
        class="btn px-4"
        :class="{
          'btn-light': $setup.theme == 'dark',
          'btn-primary': $setup.theme == 'light'
        }"
        @click="$emit('close')"
      >
        Fechar
      </button>
    </div>
  </div>
</template>
<script>
import QuizPieChart from "@/components/lesson/quiz/fragment/QuizPieChart";
import get from "lodash/get";
export default {
  components: { QuizPieChart },
  props: {
    score: {
      type: Object,
      default: () => {}
    },
    retryLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isApproved() {
      if (this.score.quiz.approval_average == 0) return true;

      return (
        this.score.quiz.approval_average > 0 &&
        this.score.score >= this.score.quiz.approval_average
      );
    },
    congrats() {
      if (get(this.score, "quiz.approval_average", 0) == 0) {
        return "Prova finalizada";
      }

      return this.isApproved ? "Parabéns" : "";
    }
  }
};
</script>
<style lang="scss" scoped></style>
